import { render, staticRenderFns } from "./MediaAccordion.vue?vue&type=template&id=3495db92"
import script from "./MediaAccordion.vue?vue&type=script&lang=js"
export * from "./MediaAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports